/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import TileContent from './TileContent';
import TileFooter from './TileFooter';
import TileHeader from './TileHeader';
import classes from './CheckTile.module.css';

const CheckTile = props => {
  const { section, check, showPopup, onFooterButtonPress } = props;
  const { color } = check || {};
  const borderColor = color || '#1a1a1a';

  return (
    <div className={classes.container} style={{ borderColor }}>
      <TileHeader check={check} showPopup={showPopup} />
      <TileContent check={check} />
      <TileFooter
        section={section}
        check={check}
        onFooterButtonPress={onFooterButtonPress}
      />
    </div>
  );
};

export default CheckTile;

CheckTile.propTypes = {
  section: PropTypes.object,
  check: PropTypes.object.isRequired,
  showPopup: PropTypes.func,
  onFooterButtonPress: PropTypes.func,
};

CheckTile.defaultProps = {
  section: {},
  check: {},
  showPopup: () => { },
  onFooterButtonPress: () => { },
};
